<script setup>
import {defineProps,ref} from 'vue';
import M from "materialize-css";
import { VueTelInput } from 'vue-tel-input'
import axios from "axios";
import conf from "../../config";
defineProps({

  isScrolled: Function

});

const isOpen      = ref(false)
const isOpenTwo   = ref(false)
const phoneNumber = ref('')
const name        = ref('')
const telegram    = ref('')

const burger = (e) =>
{
  e.currentTarget.classList.add('active');
  isOpenTwo.value = true
}

const burgerOff = (e) =>
{
  if(isOpen.value == false)
  {
    e.currentTarget.classList.remove('active');
    isOpenTwo.value = false
  }
}

const toggle = (e) =>
{
  e.stopPropagation()
  isOpen.value = !isOpen.value
}

const close = () =>
{
  isOpen.value = false
}

const offMob = ()=>
{
  document.querySelector(".sidenav-overlay").click()
}

const cleanName = (name) =>
{
  return name
      .trim()
      .replace(/\s+/g, ' ')
      .replace(/[^a-zA-Zа-яА-ЯёЁіІїЇєЄґҐ' -]/g, '');
};


const isValid = ref(false)
function handleInput(formattedNumber, phoneObject) {
  isValid.value = phoneObject?.valid ?? false
}

const send = async () => {
  const phone = phoneNumber.value;
  const nameValue = cleanName(name.value);
  if (!isValid.value) {
    M.toast({html: 'Некоректний номер', classes: 'red'})
    return false;
  }

  const message = {
    phone,
    name: nameValue || null,
    telegram: telegram.value || null,
  };

  try
  {
    var instances = M.Modal.init(document.querySelector('#form'), {});
    const response = await axios.post(conf.url + '/mail', message);
    M.toast({html: 'Дякуємо! Вашу заявку успішно надіслано. Ми зв\'яжемося з вами найближчим часом.', classes: 'green'})
    instances.close();
    phoneNumber.value = '';
    name.value = '';
    telegram.value = '';
    return response.status === 200;

  }
  catch (e)
  {
    console.log(e);
    return false;
  }
};

</script>


<template>
  <div class="navbar-fixed">
    <nav class="nav-extended" :class="{ blure: isScrolled }">
      <div class="nav-wrapper">
        <div class="container" style="z-index: 1">
          <a href="#" data-target="mobile-demo" class="sidenav-trigger">
          <span class="navbtn--burger_mobile">
             <span class="burger-lines"></span>
          </span>
          </a>
          <div class="hide-on-med-and-down nav__inner">
            <button class="navbtn navbtn--burger" @click="burger" @mouseleave="burgerOff">
              <span class="burger-lines"></span>
              <div class="burger-menu">
                <a href="#whyus" class="burger_link" :class="{ active: isOpenTwo }">Чому ми?</a>
                <a href="/beginner">Курс для Початківців</a>
                <div class="tariffs" @click="toggle">Тарифи
                  <img src="@/assets/img/back.svg" class="down">
                  <div class="dropdown" :class="{ active: isOpen }" @mouseleave="close" >
                    <a href="/independent" class="dropdown-item"  @click="close">Тариф «Самостійний»</a>
                    <a href="/standard" class="dropdown-item"  @click="close">Тариф «Стандарт»</a>
                    <a href="/personal" class="dropdown-item"  @click="close">Тариф «Personal»</a>
                  </div>
                </div>
                <a href="#tips">Про нас</a>
                <a href="https://ua-tradeup.com/courses/auth/login">Кабінет студента</a>
              </div>
            </button>

            <div class="nav__right">
              <a class="navbtn modal-trigger" href="#form">
                <svg class="buto" width="15px" height="13px">
                  <path fill-rule="evenodd"
                        d="M14.945,10.201 C15.008,10.472 15.065,10.579 14.888,10.742 L12.770,12.621 C12.712,12.733 12.529,12.840 12.409,12.891 C12.226,12.948 12.106,12.999 11.928,12.999 C11.928,12.999 11.928,12.999 11.865,12.999 C11.803,12.999 11.745,12.999 11.625,12.999 C11.442,12.999 11.081,12.999 10.657,12.948 C10.176,12.891 9.632,12.733 8.968,12.463 C8.304,12.248 7.577,11.870 6.730,11.386 C5.883,10.901 5.041,10.257 4.074,9.399 C3.352,8.751 2.746,8.103 2.259,7.515 C1.720,6.923 1.359,6.331 1.051,5.846 C0.753,5.310 0.512,4.881 0.387,4.448 C0.209,4.070 0.147,3.697 0.089,3.370 C0.027,3.104 -0.036,2.834 0.027,2.671 C0.027,2.512 0.027,2.405 0.027,2.405 C0.027,2.242 0.089,2.135 0.147,1.976 C0.267,1.864 0.330,1.757 0.450,1.650 C5.523,-2.868 5.826,3.263 5.219,3.804 L4.435,4.499 C4.435,4.499 4.435,4.555 4.377,4.555 C4.377,4.611 4.377,4.662 4.377,4.662 C4.435,4.881 4.497,5.091 4.680,5.362 C4.795,5.576 4.978,5.846 5.282,6.168 C5.523,6.546 5.883,6.923 6.369,7.352 C6.850,7.781 7.337,8.103 7.697,8.373 C8.058,8.588 8.362,8.751 8.607,8.914 C8.848,9.017 9.026,9.073 9.209,9.073 L9.387,9.128 C9.387,9.128 9.449,9.128 9.512,9.128 C9.570,9.073 9.570,9.073 9.570,9.073 C11.687,6.331 14.767,8.914 14.945,10.201 L14.945,10.201 Z"/>
                </svg>
              </a>
              <button class="navbtn navbtn--lang">
                UA
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
  <div class="sidenav" id="mobile-demo">
    <div class="logo">
      <img src="@/assets/img/mobLogo.png">
      <div v-on:click="offMob" class="close">x</div>
    </div>
    <ul class="mobMenu">
      <li class="first" v-on:click="offMob"><a href="#whyus">Чому ми?</a></li>
      <li class="second"><a href="/beginner">Курс для Початківців</a></li>
      <p>Тарифи</p>
      <ul class="mobMenuBox">
        <li><a href="/independent">Тариф «Самостійний»</a></li>
        <li><a href="/standard">Тариф «Стандарт»</a></li>
        <li><a href="/personal">Тариф «Personal»</a></li>
      </ul>
      <li class="about"  v-on:click="offMob"><a href="#tips">Про нас</a></li>
      <li class="therd"><a href="https://ua-tradeup.com/courses/auth/login">Кабінет студента</a></li>

    </ul>
    <div class="cool">
      <a v-on:click="offMob" class="navbtn modal-trigger navbtn" href="#form" >
        <svg class="buto" width="15px" height="13px">
          <path fill-rule="evenodd"
                d="M14.945,10.201 C15.008,10.472 15.065,10.579 14.888,10.742 L12.770,12.621 C12.712,12.733 12.529,12.840 12.409,12.891 C12.226,12.948 12.106,12.999 11.928,12.999 C11.928,12.999 11.928,12.999 11.865,12.999 C11.803,12.999 11.745,12.999 11.625,12.999 C11.442,12.999 11.081,12.999 10.657,12.948 C10.176,12.891 9.632,12.733 8.968,12.463 C8.304,12.248 7.577,11.870 6.730,11.386 C5.883,10.901 5.041,10.257 4.074,9.399 C3.352,8.751 2.746,8.103 2.259,7.515 C1.720,6.923 1.359,6.331 1.051,5.846 C0.753,5.310 0.512,4.881 0.387,4.448 C0.209,4.070 0.147,3.697 0.089,3.370 C0.027,3.104 -0.036,2.834 0.027,2.671 C0.027,2.512 0.027,2.405 0.027,2.405 C0.027,2.242 0.089,2.135 0.147,1.976 C0.267,1.864 0.330,1.757 0.450,1.650 C5.523,-2.868 5.826,3.263 5.219,3.804 L4.435,4.499 C4.435,4.499 4.435,4.555 4.377,4.555 C4.377,4.611 4.377,4.662 4.377,4.662 C4.435,4.881 4.497,5.091 4.680,5.362 C4.795,5.576 4.978,5.846 5.282,6.168 C5.523,6.546 5.883,6.923 6.369,7.352 C6.850,7.781 7.337,8.103 7.697,8.373 C8.058,8.588 8.362,8.751 8.607,8.914 C8.848,9.017 9.026,9.073 9.209,9.073 L9.387,9.128 C9.387,9.128 9.449,9.128 9.512,9.128 C9.570,9.073 9.570,9.073 9.570,9.073 C11.687,6.331 14.767,8.914 14.945,10.201 L14.945,10.201 Z"/>
        </svg>
      </a>
      <button class="navbtn navbtn--lang">
        UA
      </button>
    </div>
  </div>
  <div id="form" class="modal">
    <div class="modal-content">
      <div class="row mb0">
        <h4 class="modal-content--title">Почніть свій шлях у трейдингу вже сьогодні</h4>
        <p class="modal-content--text">Заповніть форму, і ми зв’яжемося з вами для консультації,<br>відповімо на запитання та допоможемо обрати оптимальну програму навчання.</p>
      </div>
      <div class="row mb0">
        <div class="input-field col s12 xl8 offset-xl2">
          <VueTelInput
              id="icon_telephone"
              v-model="phoneNumber"
              @on-input="handleInput"
              :defaultCountry="'ua'"
              :dropdown-options="{ showFlags: true }"
              :input-options="{ placeholder: '+' }"
              mode="international"
          />
          <label for="icon_telephone" class="active">Номер телефону <span class="mast">*</span></label>
        </div>
        <div class="input-field col s12 xl8 offset-xl2">
          <i class="material-icons prefix">account_circle</i>
          <input id="icon_prefix" type="text" v-model="name">
          <label for="icon_prefix" class="active">Імя</label>
        </div>
        <div class="input-field col s12 xl8 offset-xl2">
          <img src="@/assets/img/telegram.svg" class="material-icons prefix material-icons-img" />
          <input id="icon_telegram" type="text" v-model="telegram">
          <label for="icon_telegram" class="active">@telegram</label>
        </div>
        <div class="input-field col s12 xl8 offset-xl2">
          <button class="sendButton" v-on:click="send">записатись</button>
        </div>
      </div>
      <div class="row mb0">
        <div class="col s12 xl8 offset-xl2">
          <div class="modalSoceal">
            <a href="tg://resolve?domain=uatradeup"  class="link"><img src="@/assets/img/telegram.svg" alt="telegram"></a>
            <a href="viber://chat?number=+380670100133" class="link"><img src="@/assets/img/viber.svg" alt="viber"></a>
            <a href="https://www.instagram.com/uatradeup?igsh=MWo4M3prNW5venpr" class="link" target="_blank"><img src="@/assets/img/insta.svg" alt="instagram"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<style scoped>

lable
{
  font-family: HeliosExtThinC;
}

.modal
{
  border-radius: 51px;
  overflow: hidden;
  background: #000;
  font-family: HeliosExtThinC;
}

.input-field.col label
{
  left: 0!important;
}

.modal:before
{
  content: "";
  position: absolute;
  inset: 0;
  padding: 1px;
  border-radius: 51px;
  background: linear-gradient(0deg, #3d3d3d, rgba(255,255,255,0.5));
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: add, add;
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  z-index: 2;
}

.modal:after
{
  content: "";
  position: absolute;
  inset: -50%;
  background: radial-gradient(circle at top left,#0C4 35%,transparent 45%);
  filter: blur(53px);
  opacity: .6;
  transform: rotate(20deg);
  transition: all .4s ease;
}

.modal .modal-close
{
  top:20px;
  right: 40px;
  position: absolute;
  z-index: 3;
}

.modal .modal-close svg
{
  width: 40px;
}

.modal-content
{
  position: relative;
  margin: 30px 0;
  z-index: 2;

}

input
{
  color: #fff;
}

input.valid:not([type]), input.valid:not([type]):focus, input.valid[type="text"]:not(.browser-default), input.valid[type="text"]:not(.browser-default):focus, input.valid[type="password"]:not(.browser-default), input.valid[type="password"]:not(.browser-default):focus, input.valid[type="email"]:not(.browser-default), input.valid[type="email"]:not(.browser-default):focus, input.valid[type="url"]:not(.browser-default), input.valid[type="url"]:not(.browser-default):focus, input.valid[type="time"]:not(.browser-default), input.valid[type="time"]:not(.browser-default):focus, input.valid[type="date"]:not(.browser-default), input.valid[type="date"]:not(.browser-default):focus, input.valid[type="datetime"]:not(.browser-default), input.valid[type="datetime"]:not(.browser-default):focus, input.valid[type="datetime-local"]:not(.browser-default), input.valid[type="datetime-local"]:not(.browser-default):focus, input.valid[type="tel"]:not(.browser-default), input.valid[type="tel"]:not(.browser-default):focus, input.valid[type="number"]:not(.browser-default), input.valid[type="number"]:not(.browser-default):focus, input.valid[type="search"]:not(.browser-default), input.valid[type="search"]:not(.browser-default):focus, textarea.materialize-textarea.valid, textarea.materialize-textarea.valid:focus, .select-wrapper.valid > input.select-dropdown {
  border-bottom: 1px solid var(--color)!important;
  box-shadow: 0 1px 0 0 var(--color)!important;
}

input:not([type]):focus:not([readonly]),
input[type=text]:not(.browser-default):focus:not([readonly]),
input[type=password]:not(.browser-default):focus:not([readonly]),
input[type=email]:not(.browser-default):focus:not([readonly]),
input[type=url]:not(.browser-default):focus:not([readonly]),
input[type=time]:not(.browser-default):focus:not([readonly]),
input[type=date]:not(.browser-default):focus:not([readonly]),
input[type=datetime]:not(.browser-default):focus:not([readonly]),
input[type=datetime-local]:not(.browser-default):focus:not([readonly]),
input[type=tel]:not(.browser-default):focus:not([readonly]),
input[type=number]:not(.browser-default):focus:not([readonly]),
input[type=search]:not(.browser-default):focus:not([readonly]),
textarea.materialize-textarea:focus:not([readonly]) {
  border-bottom: 1px solid var(--color)!important;
  box-shadow: 0 1px 0 0 var(--color)!important;
}

input:not([type]):focus:not([readonly]) + label,
input[type=text]:not(.browser-default):focus:not([readonly]) + label,
input[type=password]:not(.browser-default):focus:not([readonly]) + label,
input[type=email]:not(.browser-default):focus:not([readonly]) + label,
input[type=url]:not(.browser-default):focus:not([readonly]) + label,
input[type=time]:not(.browser-default):focus:not([readonly]) + label,
input[type=date]:not(.browser-default):focus:not([readonly]) + label,
input[type=datetime]:not(.browser-default):focus:not([readonly]) + label,
input[type=datetime-local]:not(.browser-default):focus:not([readonly]) + label,
input[type=tel]:not(.browser-default):focus:not([readonly]) + label,
input[type=number]:not(.browser-default):focus:not([readonly]) + label,
input[type=search]:not(.browser-default):focus:not([readonly]) + label,
textarea.materialize-textarea:focus:not([readonly]) + label {
  color: var(--color)!important;
}

.input-field .prefix.active {
  color: var(--color)!important;
}

.mast
{
  position: absolute;
  top: -25px;
  font-size: 30px;
  color: red;
}

.sendButton:hover
{
  background: transparent;
  box-shadow: 0 0 0 1px var(--color);
  transition: background 0.3s ease-in-out;
  color: #fff;
}

.sendButton
{
  font-family: HeliosExtBlackC;
  font-size: clamp(8px, 0.66vw, 12.83px);
  background-color: var(--color);
  border: none;
  border-radius: 17.5px;
  padding: clamp(3.125px, 0.26041vw, 5px) clamp(31.875px, 2.65625vw, 51px) clamp(3.125px, 0.26041vw, 5px) clamp(31.875px, 2.65625vw, 51px);
  position: relative;
  cursor: pointer;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
}

.mb0
{
  margin-bottom: 0!important;
}

.modalSoceal
{
  display: flex;
  position: absolute;
  top:20px;
  right: 60px;
}

.modalSoceal .link
{
  width: 24px;
  margin: 0 15px;
}

.btn, .btn-floating, .btn-large, .btn-small, .card, .card-panel, .collapsible, .dropdown-content, .sidenav, .toast, .z-depth-1, nav
{
  box-shadow: none!important;
}

.navbar-fixed
{
  position: absolute!important;
}

.nav-extended
{
  background-color: transparent!important;
  z-index: 1;
}

.blure
{
  backdrop-filter: blur(10px);
}

.nav__inner
{
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  top: 16px;
}

.nav__right
{
  display: flex;
  gap: 16px;
}

.navbtn
{
  height: 30px;
  padding: 0;
  border-radius: 999px;
  border: 1px solid rgba(118,122,118,1);
  background: transparent;
  color: #767a76;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 68px;
}

.burger_link
{
  position: relative;
  right: -100%;
}

.burger_link.active
{
  right: 0;
}

.navbtn--burger
{
  width: 68px;
  padding: 0;
  position: relative;
  transition: width 0.4s ease;
}

.navbtn--burger::before
{
  content: '';
  position: absolute;
  inset: -20px;
}

.navbtn--burger_mobile
{
  position: relative;
  top:15px;
  height: 30px;
  padding: 0;
  border-radius: 999px;
  border: 1px solid rgba(118,122,118,1);
  background: transparent;
  color: #767a76;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 68px;
}

.sidenav-trigger
{
  cursor: pointer;
}

.navbtn--burger .burger-lines,
.navbtn--burger_mobile .burger-lines
{
  position: relative;
  width: 23px;
  height: 1px;
  background: #c8cac8;
  display: block;
}

.navbtn--burger .burger-lines::before,
.navbtn--burger .burger-lines::after,
.navbtn--burger_mobile .burger-lines::before,
.navbtn--burger_mobile .burger-lines::after
{
  content: "";
  position: absolute;
  left: 0;
  width: 23px;
  height: 1px;
  background: #c8cac8;
}

.navbtn--burger .burger-lines::before,
.navbtn--burger_mobile .burger-lines::before
{
  top: -6px;
}

.navbtn--burger .burger-lines::after,
.navbtn--burger_mobile .burger-lines::after
{
  top: 6px;
}

.burger-menu
{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  opacity: 0;
  transition: opacity 0.3s ease;
  white-space: nowrap;
}

.burger-menu a
{
  font-family: HeliosExtThinC;
  font-size: clamp(7.81px,.65vw,12.5px);
  color: #fff;
  margin: 0;
  padding: 0;
  cursor: pointer;
  padding: 10px 0;
}

.navbtn--burger.active
{
  width: 635px;
}

.navbtn--burger.active > *
{
  display: flex;
}


/* скрываем бургер */
.navbtn--burger.active .burger-lines {
  opacity: 0;
}

/* показываем текст */
.navbtn--burger.active .burger-menu {
  opacity: 1;
}

/* dropdown */

.burger-menu .tariffs
{
  position: relative;
  font-family: HeliosExtThinC;
  font-size: clamp(7.81px, 0.65vw, 12.5px);
  color: #fff;

}

.burger-menu .tariffs .down
{
  position: absolute;
  transform: rotate(-90deg);
  top: 8px;
  width: 3px;
  height: 19px;
  left: 50%;
  transition: 0.4s;
}

.dropdown
{
  position: absolute;
  top: 30px;
  left: 0;
  opacity: 0;
  pointer-events: none;
  transform: translateY(-10px);
  transition: 0.4s;
  text-align: left;
}

.dropdown.active
{
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
  background-color: #0b0f0b;
  padding: 0 15px;
  border-radius: 15px;
}

.tariffs:has(.dropdown.active) .down
{
  transform: rotate(90deg);
}

.dropdown-item
{
  font-family: HeliosExtThinC;
  font-size: 12.5px;
  color: #fff;
  padding: 5px 0;
  white-space: nowrap;
  display: block;
}

/* ===================== */

.navbtn .back
{
  width: 3px;
  height: 19px;
}

.navbtn .buto
{
  fill:rgb(250, 252, 250)
}

.navbtn--lang
{
  font-family: 'HeliosExtThinC';
  font-size: 14px;
  font-weight: 500;
  color: #fff;
}

.sidenav
{
  background-image: url("@/assets/img/mobMenu_bg.jpg");
  background-repeat: no-repeat;
  background-color: #000;
  padding: 110px 65px 110px 65px;
  min-width: 385px;
}

.sidenav .logo
{
  display: flex;
  justify-content: space-between;
  margin-bottom: 100px;
}

.sidenav .cool
{
  display: flex;
  justify-content: space-between;
  margin-top: 100px;
}

.close
{
  font-family: HeliosExtThinC;
  font-size: 20px;
  height: 39px;
  padding: 0;
  border-radius: 999px;
  border: 1px solid #c8cac8;
  background: transparent;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 68px;

}

.sidenav .mobMenu
{
  border-radius: 15px;
  border: 1px solid #c8cac8;
}


.sidenav li > a,
.sidenav p
{
  color: rgba(255, 255, 255, 1);
  font-family: HeliosExtThinC;
  display: block;
  height: auto;
  font-size: 12.5px;
  font-weight: 400;
  line-height: 12.5px;
  padding: 0 25px;
}

.sidenav .mobMenu .first
{
  margin-top: 50px;
}

.sidenav .mobMenu .second
{
  margin: 40px 0;
}

.sidenav .mobMenu .therd
{
  margin: 28px 0 60px 0;
}

.sidenav .mobMenu .mobMenuBox li
{
  padding-left: 60px;
  padding-bottom: 12px;
}

.sidenav .mobMenu .mobMenuBox li a
{
  padding:0;
}

.about
{
  margin-top: 20px;
}

/*hover*/

.navbtn--burger > *
{
  display: none;
}

.navbtn--burger:hover,
.navbtn:hover
{
  border: 1px solid #0b0f0b;
  background-color: #0b0f0b
}


/*Forma*/


.modal-content--title
{
  font-family: HeliosExtC-Bold;
  font-size: clamp(20.99px, 1.75vw, 33.58px);
  line-height: 1.1;
  letter-spacing: 0;
  text-align: center;
  margin-top: 35px;
}

.modal-content--text
{
  font-family: HeliosExtC-Bold;
  font-size: clamp(7.34px, 0.61vw, 11.75px);
  line-height: clamp(10.48px, 0.87vw, 16.76px);
  letter-spacing: 0;
  text-align: center;
  margin-bottom: 35px;
}

:deep(.vue-tel-input)
{
  border: 0px solid transparent!important;
}

:deep(.vti__input)
{
  color: #fff;
}

:deep(.vti__dropdown)
{
  padding: 0;
  margin-left: 4px;
}

:deep(.vti__dropdown:hover)
{
  background-color: transparent!important;
}

:deep(.vti__dropdown.open)
{
  background-color: transparent!important;
}

:deep(.vti__dropdown-list)
{
  background-color: #000;
  border: 1px solid #000;
}

:deep(.vti__dropdown-item.highlighted)
{
  background-color: transparent;
  color:#02ff11;
}

.material-icons-img
{
  width: 30px!important;
}

.material-icons.prefix.active
{
  color: #fff!important;
}

@media only screen and (min-width: 601px)
{
  nav.nav-extended .nav-wrapper
  {
    min-height: 60px!important;
  }

  nav, nav .nav-wrapper i, nav a.sidenav-trigger, nav a.sidenav-trigger i
  {
    line-height: 60px;
  }

}

@media (max-width: 992px)
{

  .modalSoceal
  {
    top: auto;
    right: 20px;
  }

  .modalSoceal .link
  {
    width: 16px;
    margin: 0 5px;
  }

}

</style>
